import React, { Component } from 'react';
import TransactionAudit from '../TransactionAudit/TransactionAudit';
import EditForm from '../EditForm';
import IsLoading from '../../../../../Shared/Loading/IsLoading';

class DialogContainer extends Component {
    constructor(props) {
        super(props);

        let d = { ...this.props.transactionData };
        this.state = {
            view: "details",
            data: Object.keys(this.props.transactionData).length === 0 ? null : d
        };
    }

    changeVeiw = (view) => {
        this.setState({
            view: view
        })
    }

    render() {
        return (
            <div className="k-window-content">
                <div className="row " style={{ width: '100%' }}>
                    <div className="col-md-2 larger-font">
                        {this.state.data ?
                            <ul className="subSideNav">
                                <li onClick={() => this.changeVeiw("details")} className={this.state.view === "edit" ? "active" : ""}>Edit Transaction</li>
                                <li onClick={() => this.changeVeiw("audit")} className={this.state.view === "add" ? "active" : ""}>Audit History</li>
                            </ul>
                            : ""}
                    </div>
                    <div className="col-md-10">
                        {this.state.view === "details" ?
                            <EditForm
                                transactionData={this.props.transactionData}
                                refreshGird={this.props.refreshGird}
                                cancel={this.props.cancel}
                            />
                            : ""}
                        {this.state.view === "audit" ?
                            <TransactionAudit
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                            />
                            : ""}
                    </div>
                </div>
            </div>
        );
    }
}

export default DialogContainer;

